<template>
  <MetricTotal
    :title="title"
    :item-id="itemId"
    :metric="metric"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTotal from '@/components/cards/MetricTotal';
import { POST_FIELDS } from '@/services/charts-service';

export default {
  name: 'SharesTotal',
  components: {
    MetricTotal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    metric() {
      return POST_FIELDS.SHARES;
    },
  },
};
</script>
